import type {
  PipelineBucketCount,
  PipelineHealthSummary,
} from "@redotech/redo-dispute-db-schema/dispute-pipeline";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const bySourceSchema = z.object({
  shopify: z.number().int(),
  paypal: z.number().int(),
  stripe: z.number().int(),
});

const byTypeSchema = z.object({
  chargeback: z.number().int(),
  inquiry: z.number().int(),
});

const bucketCountSchema: z.ZodType<PipelineBucketCount> = z.object({
  total: z.number().int(),
  bySource: bySourceSchema,
  byType: byTypeSchema,
});

const pipelineHealthSummarySchema: z.ZodType<PipelineHealthSummary> = z.object({
  generationOverdue: bucketCountSchema,
});

export {
  type PipelineBucketCount,
  type PipelineBySource,
  type PipelineByType,
  type PipelineHealthSummary,
} from "@redotech/redo-dispute-db-schema/dispute-pipeline";

/**
 * Returns counts for the Pipeline Health surface, broken down by
 * payment source so a platform-specific regression (Shopify API
 * change, Stripe upload outage, etc.) is visible at a glance.
 */
export const getReclaimPipelineHealth = unaryRpc({
  name: "getReclaimPipelineHealth" as const,
  input: z.object({}),
  output: pipelineHealthSummarySchema,
});
